import {
  DeleteAdvanceShippingFeeDocument,
  DeleteCountryBaseShippingFeeDocument,
} from "src/generated-gql/graphql";
import {
  addNavMenuItem,
  DataService,
  ModalService,
  NotificationService,
  registerBulkAction,
  registerFormInputComponent,
} from "@bb-vendure/admin-ui/core";
import { DefaultPlanSelectorComponent } from "./default-plan-selector/default-plan-selector.component";

export default [
  registerFormInputComponent(
    "default-country-base-shipping-fee-selector",
    DefaultPlanSelectorComponent
  ),
  addNavMenuItem(
    {
      id: "shipping-fee-v2",
      label: "shippingFee.shipping-fee",
      routerLink: ["/country-shipping-fee"],
      icon: "calculator",
      requiresPermission: (userPermissions) => {
        return userPermissions.includes("ReadShippingFee");
      },
    },
    "shipping-section"
  ),
  registerBulkAction({
    location: "country-based-shipping-list",
    label: "common.delete",
    onClick: ({ injector, selection, hostComponent, clearSelection }) => {
      const modal = injector.get(ModalService);
      const dataService = injector.get(DataService);
      const notification = injector.get(NotificationService);
      modal
        .dialog({
          title: "common.delete",
          body: "common.confirm-delete",
          buttons: [
            {
              label: "common.delete",
              type: "danger",
              returnValue: true,
            },
            {
              label: "common.cancel",
              type: "secondary",
              returnValue: false,
            },
          ],
        })
        .subscribe((result) => {
          if (result) {
            dataService
              .mutate(DeleteCountryBaseShippingFeeDocument, {
                id: selection.map((item) => item.id),
              })
              .subscribe((res) => {
                notification.success("common.deleteSuccess");
                clearSelection();
                hostComponent.refresh();
              });
          }
        });
    },
  }),
  registerBulkAction({
    location: "advance-shipping-fee-detail-list",
    label: "common.delete",
    onClick: ({ injector, selection, hostComponent, clearSelection }) => {
      const modal = injector.get(ModalService);
      const dataService = injector.get(DataService);
      const notification = injector.get(NotificationService);
      modal
        .dialog({
          title: "common.delete",
          body: "common.deleteConfirmation",
          buttons: [
            {
              label: "common.delete",
              type: "primary",
              returnValue: true,
            },
            {
              label: "common.cancel",
              type: "secondary",
            },
          ],
        })
        .subscribe((result) => {
          if (result) {
            dataService
              .mutate(DeleteAdvanceShippingFeeDocument, {
                id: selection.map((item) => item.id),
              })
              .subscribe((res) => {
                notification.success("common.deleteSuccess");
                clearSelection();
                hostComponent.refresh();
              });
          }
        });
    },
  }),
];
